<template>
  <!--查看-->
  <div>
    <RCell
      :title="tabsArr"
      @on-tab="handleClick"
      ref="tabs"
      type="cellTop"
      class="edit-title cell-top"
      :tabActive="activeSubName"
    >
      <!--<template slot="icon">
        <el-popover placement="bottom" trigger="click" popper-class="r-popover">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <br />
          <el-checkbox v-for="(column, index) in tableColumn" v-model="column.visible" :key="index" @change="_checkChange">{{column.label}}</el-checkbox>
          <el-button  type="primary" size="mini" slot="reference"  name="dataSetting" style="margin-right: 10px;">设置数据项</el-button>
        </el-popover>
        &lt;!&ndash;<el-button size="mini"  type="primary" slot="reference"  name="dataSetting" style="margin-left: 10px;" @click="handlePatchDelete">注销</el-button>&ndash;&gt;
        <el-button size="mini"  type="primary" slot="reference"  name="dataSetting" @click="importFile">导入</el-button>
        <el-button size="mini"  type="primary" slot="reference"  name="dataSetting" @click="exportData">导出</el-button>
      </template>-->
    </RCell>
    <virtual-person v-if="activeSubName=='virtual'" style="margin-top: -30px;width: 100%;"></virtual-person>
    <real-person :roomCode="roomCode" style="margin-top: -30px;width: 100%;" v-else></real-person>
  </div>
</template>

<script>
    import virtualPerson from './virtualPerson'
    import realPerson from './realPerson'
    export default {
      components: {virtualPerson,realPerson},

      name: "checkInInfo",
        data(){
          return{
            tabsArr:[{label:'实际入住人',name:'real'},{label:'拟入住人',name:'virtual'}],
            activeSubName:'real',
            tableColumn:[],
            roomCode:''
          }
      },
      created(){
        let query = this.$route.query
        if (query.roomCode) {
          this.roomCode = query.roomCode
        }
      },
      mounted(){

      },
      watch:{

      },
      methods:{
        handleClick(active){
          this.activeSubName = active
          //链接跳转后，再点击tab页就去掉查询项
          this.roomCode = ''
        }
      },
    }
</script>

